import { Collapse, List, useMediaQuery, useTheme } from "@mui/material";
import { BarChart } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../app/helpers";
import { ListItemLink } from "./list-item-link.component";
import { RootState } from "../../../app/rootReducer";

type P = {
  onToggleDrawerMobile: () => void;
  onToggleList: () => void;
  onCloseCapacityList: () => void;
  isOpen: boolean;
  isToggled: boolean;
  mobileOpen: boolean;
};

export const CapacityDrawerList: React.FC<P> = ({
  onToggleDrawerMobile,
  onToggleList,
  onCloseCapacityList,
  isOpen,
  isToggled,
  mobileOpen
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    userRoles: { isCapacityResponsible, isFleetAdmin }
  } = useSelector((state: RootState) => state.login);
  const showCapacitySection = isCapacityResponsible || isFleetAdmin;
  const { pathname } = globalThis.location; // full path
  const capacityItemLinkStyle =
    isToggled ||
    (pathname.includes("capacity") &&
      !pathname.includes("equipment") &&
      !pathname.includes("service"))
      ? {
          fontSize: "0.8rem",
          boxShadow: "inset 3px 0 0 0 " + theme.palette.primary.main
        }
      : undefined;
  const subItemLinkStyle = {
    height: "40px",
    fontSize: "0.8rem",
    boxShadow: "inset 3px 0 0 0 " + theme.palette.primary.main
  };

  return (
    <List
      disablePadding
      sx={[
        isOpen
          ? {
              paddingLeft: "11%"
            }
          : {
              paddingLeft: 0
            }
      ]}
    >
      {showCapacitySection && (
        <ListItemLink
          id="capacity"
          to={"/capacity"}
          primary={t("Capacity")}
          data-testid="drawer-capacity-toggle"
          icon={<BarChart />}
          onClick={e => {
            e.preventDefault();
            if (isToggled) return onCloseCapacityList();
            onToggleList();
          }}
          navLinkStyleProps={capacityItemLinkStyle}
          isToggled={isToggled}
        />
      )}
      {/* sub item list */}
      {(isOpen || (mobileOpen && isMobile)) && (
        <Collapse in={isToggled}>
          <List
            onClick={() => onToggleDrawerMobile()}
            component="div"
            disablePadding
            data-testid="drawer-capacity-collapse-list"
          >
            {isCapacityResponsible && (
              <ListItemLink
                to={"/capacity/map"}
                navLinkStyleProps={subItemLinkStyle}
                primary={t("Heatmap")}
                data-testid="capacity-mapReport"
              />
            )}
            {isCapacityResponsible && (
              <ListItemLink
                navLinkStyleProps={subItemLinkStyle}
                to={"/capacity/assistant"}
                primary={t("Assistant")}
                data-testid="capacity-assistant"
              />
            )}
            {isCapacityResponsible && (
              <ListItemLink
                navLinkStyleProps={subItemLinkStyle}
                to={"/capacity/departmentReport"}
                primary={t("DistributionReport")}
                data-testid="capacity-department-kpi"
              />
            )}

            {isFleetAdmin && (
              <ListItemLink
                navLinkStyleProps={subItemLinkStyle}
                to={"/capacity/fleet"}
                primary={t("Drawer_Fleet")}
                data-testid="capacity-fleet"
              />
            )}
          </List>
        </Collapse>
      )}
    </List>
  );
};
